import * as React from "react";
import cx from "classnames";

import styles from "./AnimateOnReveal.module.scss";

export const AnimateOnReveal = ({ animation, classNames, children }) => (
  <div className={cx(styles[animation], classNames)}>{children}</div>
);
